import ReactModal from "react-modal";
import {redirectModal as strings} from "strings";

import Button from "components/Button";

import {Pharmacy} from "liberty-core/api/models";

import styles from "./RedirectModal.module.css";

type Props = {
  visible: boolean;
  redirectParams: URLSearchParams;
  pharmacy: Pharmacy;
  redirectRouteWeb: string;
  redirectRouteMobile: string;
};

export default function RedirectModal(prop: Props) {
  return (
    <ReactModal
      isOpen={prop.visible}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <h2 className={styles.title}>{strings.title}</h2>
      <span className={styles.message}>{strings.message}</span>
      <Button to={prop.redirectRouteWeb}>{strings.web}</Button>
      <Button to={prop.redirectRouteMobile}>{strings.mobile}</Button>
    </ReactModal>
  );
}
